import { fetchClient } from '../../Utils/helpers';
import { getUserData } from '../../Utils/storages';
import {
  CREATE_NEW_STORAGES,
  DELETE_STORAGES,
  GET_BOX,
  GET_BOX_DETAILS,
  GET_USER_ITEM,
  GET_USER_ITEMS,
  MOVE_STORAGE_SITE_LOCATION,
  NOTIFY_USER_BROKEN_ITEM,
  RESET_BOX_COLUMN,
  SET_BOX_COLUMN,
} from '../actionTypes';

const userData = getUserData();
const role = userData.role_id;

export function moveStorageSiteLoc(data = {}) {
  return {
    type: MOVE_STORAGE_SITE_LOCATION,
    payload: fetchClient({
      method: 'PATCH',
      url: `/${role === 'Warehouse Manager' ? 'warehouse-manager' : 'admin'}/digital-box/move`,
      data,
    }),
  };
}

export function getDigitalBox(type = '') {
  return {
    type: GET_BOX,
    payload: fetchClient({
      method: 'GET',
      url: `/${role === 'Warehouse Manager' ? 'warehouse-manager' : 'admin'}/digital-box?type=${type}`,
    }),
  };
}

export function getDigitalBoxDetails(boxId) {
  return {
    type: GET_BOX_DETAILS,
    payload: fetchClient({
      method: 'GET',
      url: `/${role === 'Warehouse Manager' ? 'warehouse-manager' : 'admin'}/digital-box/${boxId}`,
    }),
  };
}

export function getUserDigitalBoxes(userId) {
  return {
    type: GET_BOX,
    payload: fetchClient({
      method: 'GET',
      url: `/user/${userId}/digital-boxes`,
    }),
  };
}

export function getUserItems(userId, { sort = '' } = {}) {
  return {
    type: GET_USER_ITEMS,
    payload: fetchClient({
      method: 'GET',
      url: `/user/${userId}/all-items?sort=${sort}`,
    }),
  };
}

export function getUserItem(userId, itemId) {
  return {
    type: GET_USER_ITEM,
    payload: fetchClient({
      method: 'GET',
      url: `/user/${userId}/item/${itemId}`,
    }),
  };
}

export function getUserDigitalBoxDetails(userId, boxId) {
  return {
    type: GET_BOX_DETAILS,
    payload: fetchClient({
      method: 'GET',
      url: `/user/${userId}/digital-box/${boxId}`,
    }),
  };
}

export function createNewStorages(data) {
  return {
    type: CREATE_NEW_STORAGES,
    payload: fetchClient({
      method: 'POST',
      url: '/admin/digital-box',
      data,
    }),
  };
}

export function deleteStorage(id) {
  return {
    type: DELETE_STORAGES,
    payload: fetchClient({
      method: 'DELETE',
      url: `/admin/digital-box/${id}`,
    }),
  };
}

export function notifyUserBrokenItem(id) {
  return {
    type: NOTIFY_USER_BROKEN_ITEM,
    payload: fetchClient({
      method: 'POST',
      url: `/admin/replace/${id}`,
    }),
  };
}

export function setBoxColumn(id, rack, column, needstorage) {
  return {
    type: SET_BOX_COLUMN,
    payload: {
      id,
      rack,
      column,
      needstorage,
    },
  };
}

export function resetBoxColumn(id, rack, column) {
  return {
    type: RESET_BOX_COLUMN,
    payload: {
      id,
      rack,
      column,
    },
  };
}
